import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { FONT_OPTIONS, SIZE_OPTIONS, descStyle } from "@/lib/fonts";
import { Type } from "lucide-react";

export function DescriptionEditor({ value, onChange, testid = "desc" }) {
  const v = value || {};
  const patch = (k, val) => onChange({ ...v, [k]: val });
  const selectCls = "rounded-xl border border-slate-200 bg-white text-sm px-3 py-2 outline-none focus:border-orange-400";

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-slate-700 flex items-center gap-1.5"><Type className="w-4 h-4" /> Description</label>
      <Textarea
        data-testid={`${testid}-text`}
        placeholder="Describe your event. Line breaks and spacing you add here will show exactly as typed."
        value={v.description || ""}
        onChange={(e) => patch("description", e.target.value)}
        className="rounded-xl"
        rows={5}
      />
      <div className="flex flex-wrap gap-2 items-center">
        <select data-testid={`${testid}-font`} value={v.font_family || ""} onChange={(e) => patch("font_family", e.target.value)} className={selectCls}>
          {FONT_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <select data-testid={`${testid}-size`} value={v.font_size || 16} onChange={(e) => patch("font_size", Number(e.target.value))} className={selectCls}>
          {SIZE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <div className="flex items-center gap-1.5 text-sm text-slate-600">
          <span>Letter spacing</span>
          <input data-testid={`${testid}-spacing`} type="number" step="0.5" min="-2" max="12" value={v.letter_spacing || 0}
            onChange={(e) => patch("letter_spacing", Number(e.target.value))}
            className="w-16 rounded-xl border border-slate-200 px-2 py-2 text-sm outline-none focus:border-orange-400" />
          <span className="text-slate-400">px</span>
        </div>
      </div>
      {v.description && (
        <div className="rounded-xl bg-slate-50 border border-slate-100 p-4">
          <p className="text-xs text-slate-400 mb-1">Live preview</p>
          <div data-testid={`${testid}-preview`} className="text-slate-700" style={descStyle(v)}>{v.description}</div>
        </div>
      )}
    </div>
  );
}
